export enum PublishersDrawerHeapEvents {
  unlinkListing = 'home-publishers-drawer-unlink-listing',
}
